import { useState, useCallback } from 'react';
import type { ReactNode } from 'react';
import { RoomsContext } from './rooms-context-base';

export function RoomsProvider({ children }: { children: ReactNode }) {
  const [listeners, setListeners] = useState<Set<() => void>>(new Set());

  const addListener = useCallback((listener: () => void) => {
    setListeners(prev => new Set(prev).add(listener));
    
    // Return cleanup function
    return () => {
      setListeners(prev => {
        const newSet = new Set(prev);
        newSet.delete(listener);
        return newSet;
      });
    };
  }, []);

  const refreshRooms = useCallback(() => {
    listeners.forEach(listener => listener());
  }, [listeners]);

  return (
    <RoomsContext.Provider value={{ refreshRooms, addListener }}>
      {children}
    </RoomsContext.Provider>
  );
}

